import { stringifyr } from '@epihub/core/src/stringifyr/core';
import type { Model } from './model';

export const sfyr = stringifyr.model<
  Model,
  {
    lang: string;
  }
>(({ z }) => ({
  context: {
    // Default language
    lang: 'en',
  },
  schema: {
    'ui.{lang}.first_intro_message': {
      type: z.markdown(),
    },
    'ui.{lang}.input_placeholder': {
      type: z.string(),
    },

    'ui.{lang}.calendar.title': {
      type: z.string(),
    },

    'ui.{lang}.dock.open_calendar': {
      type: z.string(),
    },
    'ui.{lang}.dock.homepage': {
      type: z.string(),
    },
    'ui.{lang}.dock.change_language': {
      type: z.string(),
    },

    'ui.{lang}.calendar.events.{slug}': {
      type: z.object({
        duration: z.string(),
        title: z.string(),
        description: z.string(),
      }),
    },

    ['ui.social.{type}']: {
      type: z.object({
        url: z.url(),
      }),
    },
    'ui.{lang}.default_quick_responses': {
      type: z.array(z.object({
        emoji: z.string(),
        content: z.string(),
      })),
    },

    'llm.career_promoter_agent.system_prompt': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.set_sound.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.update_quick_responses.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.open_calendar.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.set_user_name.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.misuse_rate.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.download_cv.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.auto_message.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.change_language.description': {
      type: z.string(),
    },
    'llm.career_promoter_agent.tools.change_theme.description': {
      type: z.string(),
    },
  },
}));
